import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'log-accessi',
    initialState: {
        log_accessi: [],
        statusAction: 'READY',
    },
    actions: ['GET_LOG_ACCESSI'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.GET_LOG_ACCESSI_SUCCESS:
                return {
                    ...state,
                    log_accessi: action.payload.log_accessi,
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        getLogAccessiRequest: (codiceUtente) => ({
            type: types.GET_LOG_ACCESSI_REQUEST,
            payload: { codiceUtente },
        }),
        getLogAccessiSuccess: ({ log_accessi }) => ({
            type: types.GET_LOG_ACCESSI_SUCCESS,
            payload: { log_accessi },
        }),
        getLogAccessiFailed: error => ({ type: types.GET_LOG_ACCESSI_FAILED, error: true, payload: { error } }),
    }),
});
